import * as React from "react";
const SvgFiRrSquareA = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-square-a_svg__a)">
      <path
        fill="#062147"
        d="M19.019-.077h-14c-2.757 0-5 2.243-5 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-14c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3h-14c-1.654 0-3-1.346-3-3v-14c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zM15.13 7.105a3.27 3.27 0 0 0-3.112-2.198 3.26 3.26 0 0 0-3.11 2.19l-3.83 10.5a1 1 0 1 0 1.879.685L8.155 15h7.726l1.197 3.282a1 1 0 1 0 1.879-.685zM8.885 13l1.906-5.226c.286-.805 1.012-.867 1.227-.867s.942.062 1.23.875L15.15 13H8.884"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-square-a_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSquareA;
